import { FC } from 'react';

import ProductExcipientListing from 'components/main/ProductExcipient';

const ProductExcipient: FC = () => <ProductExcipientListing />;

export default ProductExcipient;
